var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100vh" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_c("w-fa", { staticClass: "mts mr", attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-container",
        { style: { height: "92%" } },
        [
          _c(
            "w-breadcrumb",
            [
              _c(
                "div",
                {
                  staticClass: "light-selects",
                  style: { marginTop: "8px", marginLeft: "5px" },
                },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.vatRegimeItems,
                      label: _vm.$ct("vat-choose"),
                      light: "",
                    },
                    model: {
                      value: _vm.VatRegime,
                      callback: function ($$v) {
                        _vm.VatRegime = $$v
                      },
                      expression: "VatRegime",
                    },
                  }),
                  _c("w-select", {
                    attrs: {
                      items: _vm.selectablePriceCategories,
                      label: _vm.$ct("price-category-choose"),
                      light: "",
                    },
                    model: {
                      value: _vm.PriceCategory,
                      callback: function ($$v) {
                        _vm.PriceCategory = $$v
                      },
                      expression: "PriceCategory",
                    },
                  }),
                ],
                1
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                { staticClass: "cancel mr", on: { click: _vm.back } },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c(
                "w-button",
                { attrs: { icon: "check" }, on: { click: _vm.save } },
                [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
              ),
            ],
            1
          ),
          _vm.loaded
            ? _c(
                "w-row",
                {
                  style: { flexGrow: 1, position: "relative" },
                  attrs: { shrink: "" },
                },
                [
                  _c(
                    "w-col",
                    {
                      staticClass: "max-height",
                      style: { heigth: "100%" },
                      attrs: { xs: "12" },
                    },
                    [
                      _c("app-product-table-editable", {
                        attrs: {
                          items: _vm.product.Composition,
                          "selected-row": _vm.selectedRow,
                          "price-category": _vm.PriceCategory,
                          "vat-regime": _vm.VatRegime,
                        },
                        on: {
                          add: function ($event) {
                            return _vm.onAddRow($event)
                          },
                          select: function ($event) {
                            return _vm.onSelectRow($event)
                          },
                          remove: function ($event) {
                            return _vm.remove($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                { style: { height: "100%" } },
                [
                  _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-spacer"), _c("w-progress-circular"), _c("w-spacer")],
                    1
                  ),
                ],
                1
              ),
          _c("app-totals", {
            attrs: {
              "selected-row": _vm.selectedRow,
              product: _vm.product,
              totalable: _vm.product,
              valid: _vm.valid,
              "toggle-profit": true,
            },
            on: {
              save: function ($event) {
                return _vm.save()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }